module.exports = __webpack_public_path__ + "static/media/payroll.4eba0b8e.png";